import { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Sport } from '@sorare/core/src/__generated__/globalTypes';
import { Button } from '@sorare/core/src/atoms/buttons/Button';
import { NewScarcityIcon } from '@sorare/core/src/atoms/icons/ScarcityIcon';
import { Horizontal } from '@sorare/core/src/atoms/layout/flex';
import { useConversionCredits } from '@sorare/core/src/hooks/useConversionCredits';
import { glossary } from '@sorare/core/src/lib/glossary';
import { PlayerSearchViewAttributes } from '@sorare/core/src/lib/playerSearchView';
import { ClickInstantBuy_Flow } from '@sorare/core/src/protos/events/so5/shared/events';
import { regularMaterial } from '@sorare/core/src/style/utils';

import { PlayerMarketDrawer } from '@sorare/marketplace/src/components/player/PlayerMarketDrawer';
import { useManagePlayerSearchView } from '@sorare/marketplace/src/searchCommonPlayer/StatsManager/useManagePlayerSearchView';

const Root = styled(Horizontal)`
  position: sticky;
  bottom: 0;
  z-index: 1;
  ${regularMaterial}
  padding: var(--double-unit);
  border-top: 1px solid var(--c-nd-150);
`;

type Props = {
  playerSlug: string;
  sport: Sport;
};
export const WithListingsFooter = ({ playerSlug, sport }: Props) => {
  const [playerDrawerSlug, setPlayerDrawerSlug] = useState<string | null>(null);
  const { statsManager } = useManagePlayerSearchView();
  const { conversionCredits } = useConversionCredits({
    sport,
  });
  const canUseConversionCredit = conversionCredits?.some(cc => !cc.disabled);

  return (
    <>
      <Root>
        <Button
          fullWidth
          size="medium"
          color="secondary"
          onClick={() => {
            setPlayerDrawerSlug(playerSlug);
          }}
        >
          <NewScarcityIcon
            size={2}
            rarity={statsManager[PlayerSearchViewAttributes.RARITY]}
          />
          <FormattedMessage {...glossary.listings} />
        </Button>
      </Root>
      <PlayerMarketDrawer
        canUseConversionCredit={canUseConversionCredit}
        playerSlug={playerDrawerSlug}
        onClose={() => {
          setPlayerDrawerSlug(null);
        }}
        clickInstantBuyFlow={ClickInstantBuy_Flow.MATCH_CENTER}
      />
    </>
  );
};
